// Public race pages: vote buttons, the countdown and the shareable result card.
import { applyOrder, countdown, loginUrl, markVoted, setVoted, type VoteResult } from '../lib/vote'
import { drawPodiumCard } from '../lib/podium-card'
import { installShare } from '../lib/share'

installShare()

const status = document.querySelector<HTMLElement>('[data-vote-status]')
const say = (text: string) => status && (status.textContent = text)

if (document.querySelector('[data-vote]')) {
  fetch('/me.json', { credentials: 'same-origin' })
    .then((r) => r.json())
    .then((me: { voted: number[]; mine?: number[] }) => markVoted(document, me.voted, me.mine ?? []))
    .catch(() => undefined)
}

document.addEventListener('click', async (event) => {
  const button = (event.target as Element).closest<HTMLButtonElement>('[data-vote]')
  if (!button || button.disabled) return
  button.disabled = true
  try {
    const response = await fetch(button.dataset.voteUrl!, { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' } })
    const data: VoteResult = await response.json().catch(() => ({}))
    if (response.status === 401 && data.login) {
      location.href = loginUrl(data.login, location.pathname)
      return
    }
    if (!response.ok) throw new Error(data.error || 'Your vote did not go through. Try again.')
    setVoted(button)
    say(data.note || 'Vote counted.')
    // The running order on this page, and the track (track.ts) if it is here too.
    if (data.order) applyOrder(document, data.order)
    document.dispatchEvent(new CustomEvent('launchgp:vote', { detail: { ...data, entry: Number(button.dataset.vote) } }))
  } catch (e) {
    button.disabled = false
    say((e as Error).message)
  }
})

const clock = document.querySelector<HTMLElement>('[data-countdown]')
const clockValue = clock?.querySelector<HTMLElement>('[data-countdown-value]')
if (clock && clockValue) {
  const to = Date.parse(clock.dataset.countdown!)
  const tick = () => (clockValue.textContent = countdown(to, Date.now()))
  tick()
  setInterval(tick, 1000)
}

const card = document.querySelector<HTMLCanvasElement>('[data-podium-card]')
if (card) {
  let art: HTMLCanvasElement | undefined
  const draw = () => drawPodiumCard(card, { ...(card.dataset as Record<string, string>) } as never, art)
  void document.fonts?.ready.then(draw)
  draw()
  // The car and the posed driver, rendered in 3D once the card is near the screen.
  if (card.dataset.car) {
    const load = new IntersectionObserver(async ([entry]) => {
      if (!entry.isIntersecting) return
      load.disconnect()
      const { renderCardArt } = await import('../lib/card-3d')
      const paint = JSON.parse(card.dataset.paint || '{}')
      art = await renderCardArt({
        car: card.dataset.car as never, pose: (card.dataset.pose || 'normal') as never,
        livery: { ...paint, panel: card.dataset.panel || undefined }, driver: JSON.parse(card.dataset.driver || '{}'),
      }).catch(() => undefined)
      draw()
    }, { rootMargin: '400px' })
    load.observe(card)
  }
  document.querySelector('[data-podium-download]')?.addEventListener('click', () => {
    const link = document.createElement('a')
    link.download = `${(card.dataset.name || 'launchgp').toLowerCase().replace(/[^a-z0-9]+/g, '-')}-launchgp.png`
    link.href = card.toDataURL('image/png')
    link.click()
  })
}
